<template>
  <div>
    <div
      class="modal fade show"
      tabindex="-1"
      style="display: block"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header d-none d-sm-block border-0">
            <button type="button" class="close" @click="closeModal">
              &times;
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <div class="form-group">
                <label>Assign Task To</label>
                <div class="position-relative search-wrapper">
                  <input
                    type="text"
                    class="form-control search-input"
                    placeholder="Search by name, title"
                    v-model="q"
                  />
                  <i class="fas fa-search" style="color: #303030"></i>
                </div>
              </div>
            </div>

            <div class="col-12 pb-4">
              <div
                class="d-flex mt-4 justify-content-between"
                v-for="(staff, key) in staffs"
                :key="key"
              >
                <div class="d-flex">
                  <div class="px-1 align-self-center">
                    <div class="mr-2">
                      <user-avatar :avatarURL="staff.avatar_src"></user-avatar>
                    </div>
                  </div>
                  <div class="px-1 align-self-center">
                    <div
                      class="modal-name"
                      v-text="staff.display_name || staff.name"
                    ></div>
                    <div
                      class="modal-designation"
                      v-text="staff.designation"
                    ></div>
                    <div
                      class="modal-email"
                      v-bind:class="{
                        name: !(staff.display_name || staff.name),
                        sub: staff.display_name || staff.name,
                      }"
                      v-text="staff.email"
                    ></div>
                  </div>
                </div>
                <div class="px-1">
                  <button
                    class="btn btn-add"
                    @click="addMember(staff)"
                    v-if="!memberAdded(staff)"
                  >
                    Add
                    <i class="fas fa-plus"></i>
                  </button>

                  <button
                    class="btn btn-added"
                    @click="removeMember(staff)"
                    v-else
                  >
                    Added
                    <img
                      v-bind:src="'/images/added.png'"
                      alt
                      style="width: 14px; padding-bottom: 3px"
                    />
                  </button>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 text-center mb-5">
                <button class="btn btn-done" @click="passSelection">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  props: ["existingMembers"],

  data() {
    return {
      members: new Map(),
      removing: new Map(),
      newMembers: new Map(),
      staffs: [],
      q: "",
    }
  },

  computed: {
    checkBoxIcon() {
      if (!this.completedAt) return "/images/checkbox_unchecked.png"
      return this.inputTitle
        ? "/images/checkbox_checked.png"
        : "/images/checkbox_checked_static.png"
    },
  },

  watch: {
    q() {
      this.executeSearch()
    }
  },

  methods: {
    executeSearch: _.debounce(function () {
      this.getStaffs()
    }, 500),

    removeMember(staff) {
      if (this.members.has(staff.id)) {
        this.removing = new Map(this.removing.set(staff.id, staff))
      }

      if (this.newMembers.has(staff.id)) {
        let tempMap = this.newMembers
        tempMap.delete(staff.id)
        this.newMembers = new Map(tempMap)
      }
    },

    memberAdded(staff) {
      return (
        (this.members.has(staff.id) || this.newMembers.has(staff.id)) &&
        !this.removing.has(staff.id)
      )
    },

    addMember(staff) {
      if (!this.members.has(staff.id) && !this.newMembers.has(staff.id)) {
        this.newMembers = new Map(this.newMembers.set(staff.id, staff))
      }

      if (this.removing.has(staff.id)) {
        let tempMap = this.removing
        tempMap.delete(staff.id)
        this.removing = new Map(tempMap)
      }
    },

    async getStaffs() {
      const url = "/team-members?q=" + this.q
      this.data = await axios.get(url).then((data) => data.data)
      this.staffs = this.data.data
    },

    closeModal() {
      this.$emit("closeModal")
    },

    passSelection() {
      this.$emit("receiveStaffs", this.newMembers, this.removing)
      this.$emit("closeModal")
    },
  },

  mounted() {
    this.getStaffs()
    this.newMembers = this.existingMembers
  },
};
</script>

<style scoped lang="scss">
.modal-content {
  position: relative;

  .close {
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(135deg, #000 0%, #28282e 100%);
    border-radius: 100%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    opacity: 1;
    color: white;
  }

  label {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  .modal-name {
    color: #303030;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0;
    /* line-height: 22px; */
  }

  .modal-designation {
    color: #303030;
    font-family: "Open Sans";
    font-size: 10px;
    letter-spacing: 0;
    /* line-height: 22px; */
  }

  .modal-email {
    color: #808fa4;
    font-family: "Open Sans";
    font-size: 10px;
    letter-spacing: 0;
    /* line-height: 22px; */
  }
}

.action-wrapper {
  z-index: 9999;
}

.task {
  border-radius: 0.25rem;
  flex-wrap: wrap;

  .task-title {
    height: auto;
    line-height: 1.3em;
  }

  .task-title-input {
    resize: none;
    overflow: hidden;
    border-radius: 3px 0 0 3px;
    line-height: 1.3em;
  }

  .task-time {
    font-size: 0.6rem;
    line-height: 1.2em;
    max-width: 60px;
    white-space: normal;
  }

  .task-checkbox {
    height: 23px;
    width: 23px;
    border: 1px solid #bfcbde;
    border-radius: 3px;
    background-color: #fff;

    svg {
      fill: #f2f2f2;
    }
  }

  .checked {
    background-color: #0096f5;
    border: none !important;

    svg {
      fill: #fff;
    }
  }

  .can_uncheck {
    svg {
      fill: #fff !important;
    }
  }
}

.btn-add {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  color: #303030;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  /* line-height: 22px; */
  padding: 6px 8px 5px 8px !important;
  width: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-added {
  border-radius: 6px;
  background-color: #82df6b;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  color: #fff;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  padding: 6px 8px 5px 8px !important;
  /* line-height: 22px; */
}

.search-wrapper {
  .search-input {
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    border: 1px solid #dce2ed !important;
    background: white;
    padding-left: 2rem;
  }

  .fa-search {
    color: rgb(48, 48, 48);
    position: absolute;
    top: 4px;
    display: flex;
    width: 32px;
    height: 32px;
    align-items: center;
    justify-content: center;
  }
}

.btn-done {
  height: 56px;
  width: 280px;
  color: #fff;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 22px;
  text-align: center;
  background: #000;
}
</style>
